import { format as fnsFormat } from 'date-fns'
import { enUS } from 'date-fns/locale'

import { locales } from '../hooks/useLocale'

export function formatDate(date: Date | string, format?: string, locale?: string): string
export function formatDate(date: undefined | null, format?: string, locale?: string): undefined
export function formatDate(date: Date | string | null | undefined, format?: string, locale?: string): string | undefined
export function formatDate(
  date: Date | undefined | string | null,
  format = 'yyyy-MM-dd',
  locale?: string,
): string | undefined {
  if (!date) {
    return
  }

  const baseLocale = locale?.split('-')[0] || ''
  const localeObject = locales?.[baseLocale] ?? enUS

  return fnsFormat(new Date(date), format, { locale: localeObject })
}
